import { IRemoteExperienceService } from "@core/interface";
import { IPreferreddealerType } from "../dealership/preferreddealer-type";
import { IDealerServiceHours } from "./dealer-service-hours.model";
// TODO: apagar isso depois de criar o arquivo correto
export interface IDealerByLocation {
  dealerId: number;
  dealerName: string;
  dealerLocalName: string;
  distance: number;
  phone: string;
  address: string;
  city: string;
  state: string;
  latitude: number;
  longitude: number;
  pickupAndDelivery: boolean;
  winchService: boolean;
  serviceHours: IDealerServiceHours[];
  services: IRemoteExperienceService[];
  highestTimeWeek: string;
  lowestTimeWeek: string;
  highestTimeWeekend: string;
  lowestTimeWeekend: string;
  lowestDay: number;
  openSaturday: boolean;
  openSunday: boolean;
  preferredDealerType: IPreferreddealerType;
  countryCode: string;
  zipCode: string;
  dealerLocatorServices: string[];
  selected: boolean;
  acceptsOnlinePayments: boolean;
  mobileService: boolean;
  serviceSpecialist?: string;
  isUnavailable?: boolean;
}
